import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAppSelector } from '@/hooks/appHook'
import { getLang } from '@/store/language/language'
import { buildReturnPath, getSsoParams } from '@/utils/auth/sso'

// SSO is available on every page: an external resource may open any address
// with `member_id` + `otp` in the query. The credentials are handed over in the
// history state and the address they came with is replaced, so the otp never
// stays in the URL or in the history.
const RootRoute = () => {
  const lang = useAppSelector(getLang)
  const location = useLocation()

  const ssoParams = getSsoParams(location.search)
  if (ssoParams) {
    return <Navigate
      to={'/' + lang + '/sso'}
      state={{
        ...ssoParams,
        from: buildReturnPath(location.pathname, location.search)
      }}
      replace
    />
  }

  return <Outlet/>
}

export default RootRoute
